import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

import './BossModeBadge.styles.scss';

type BossModeBadgeProps = {
  className?: string;
};

const BossModeBadge: React.FC<BossModeBadgeProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  const { isSuperAdmin } = useContext(CurrentUserContext);

  const classes = classNames('boss-mode-badge', className);

  if (!isSuperAdmin) return null;

  return <div className={classes}>{t('bossMode')}</div>;
};

export default BossModeBadge;
